import { createContext } from 'react';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface NotificationsContextProps {
}

const NotificationsContext = createContext<NotificationsContextProps | undefined>(undefined);

export default NotificationsContext;